import {get} from "./helper/get";
import {isNullOrUndefined, isDefined, isNull} from "./helper/utils";
import { textWidth } from "./helper/dom";
const ApiService = require("./services/ApiService");

const Vue = (typeof window !== 'undefined' && window.Vue) || (typeof global !== 'undefined' && global.Vue) || undefined
const VuexGlobal = (typeof window !== 'undefined' && window.Vuex) || (typeof global !== 'undefined' && global.Vuex) || undefined
const mapState = VuexGlobal && typeof VuexGlobal.mapState === 'function' ? VuexGlobal.mapState : null


Vue.component('add-to-basket', {
    name: 'add-to-basket',

    props: {
        itemUrl: String,
        showQuantity: {
            type: Boolean,
            default: false,
        },
        useLargeScale: {
            type: Boolean,
            default: false,
        },
        variationId: {
            type: Number,
        },
        quickselectIds: {
            type: Array,
        },
        quickselect: {
            type: Array,
        },
        isSalable: {
            type: Boolean,
            default: false,
        },
        hasChildren: {
            type: Boolean,
            default: false,
        },
        intervalQuantity: {
            type: Number,
            default: 1,
        },
        minimumQuantity: {
            type: Number,
            default: 0,
        },
        maximumQuantity: {
            type: Number,
            default: null,
        },
        orderProperties: {
            type: Array,
            default: () => [],
        },
        hasOrderProperties: {
            type: Boolean,
            default: false,
        },
        hasPrice: {
            type: Boolean,
            default: true,
        },
        paddingClasses: {
            type: String,
            default: null,
        },
        paddingInlineStyles: {
            type: String,
            default: null,
        },
        isWishList: {
            type: Boolean,
            default: false,
        },
        propQuantity: {
            type: Number,
            default: null,
        },
        itemType: {
            type: String,
            default: null,
        },
    },

    inject: {
        itemId: {
            default: null,
        },
    },

    computed: {
        isSet() {
            return (
                (this.$store.state.items[this.itemId] &&
                    this.$store.state.items[this.itemId].variation &&
                    this.$store.state.items[this.itemId].variation.documents[0].data.item.itemType === 'set') ||
                this.itemType === 'set'
            )
        },
        canBeAddedToBasket() {
            return (
                this.isSalable &&
                !this.hasChildren &&
                !(this.minimumQuantity != 1 || this.intervalQuantity != 1) &&
                !this.requiresProperties &&
                this.hasPrice &&
                !this.isSet
            )
        },
        requiresProperties() {
            return (
                App.config.item.requireOrderProperties &&
                (this.hasOrderProperties || this.orderProperties.filter((property) => property.property.isShownOnItemPage).length > 0)
            )
        },
        buttonClasses() {
            return ['btn-lg'];
        },
        tooltipText() {
            if (this.hasAvailableVariations) {
                return this.$translate('Ceres::Template.singleItemPleaseSelectValidVariation')
            } else {
                return this.$translate('Ceres::Template.singleItemPleaseSelectNotAvailable')
            }
        },
        variationOrderQuantity() {
            return this.$store.state.items[this.itemId] && this.$store.state.items[this.itemId].variationOrderQuantity
        },
        variationMissingProperties() {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`]
        },
        hasAvailableVariations() {
            return (
                this.$store.state.items[this.itemId] &&
                this.$store.state.items[this.itemId].variationSelect &&
                this.$store.state.items[this.itemId].variationSelect.variations.some((variation) => variation.isSalable)
            )
        },
        allVariationsSelected() {
            if (this.isSet) {
                return this.$store.getters['itemSetAllVariationSelected']
            } else {
                // FIX return true if module is not registered. This equals the default value from the module
                // and is required to use this component in other contexts, e.g. the category view
                return (
                    !this.$store.state.items[this.itemId] ||
                    (this.$store.state.items[this.itemId].variationSelect && this.$store.state.items[this.itemId].variationSelect.isVariationSelected)
                )
            }
        },
        isLoading() {
            return this.$store.state.items.isAddToBasketLoading === this.variationId || this.$store.state.items.isSetLoading
        },
        ...(mapState ? mapState({ basketItems: (state) => state.basket.items, isBasketLoading: (state) => state.basket.isBasketLoading }) : {}),
    },

    data() {
        return {
            quantity: 1,
            buttonLockState: false,
        }
    },

    methods: {
        /**
         * add an item to basket-resource
         */
        addToBasket() {
            this.$store.dispatch('loadComponent', 'add-item-to-basket-overlay')
            this.$store.dispatch('loadComponent', 'basket-preview')
            if (this.variationMissingProperties !== undefined && this.variationMissingProperties.length) {
                this.showMissingPropertiesError()
            } else if (this.isSalable || this.isSet) {
                this.$store.commit('setIsAddToBasketLoading', this.variationId)
                const orderParamsAndSurcharge = extractPropertiesAndSurcharge(this.orderProperties)

                const basketObject = {
                    variationId: this.variationId,
                    quantity: this.quantity,
                    basketItemOrderParams: orderParamsAndSurcharge.orderParams,
                    totalOrderParamsMarkup: orderParamsAndSurcharge.totalSurcharge,
                }

                // bestehende Daten laden oder leeres Objekt
                const quickselectStorage = JSON.parse(localStorage.getItem('basket_quickselect') || '{}')

                // sicherstellen, dass es für diese variationId ein Array gibt
                if (!Array.isArray(quickselectStorage[this.variationId])) {
                    quickselectStorage[this.variationId] = []
                }

                quickselectStorage[this.variationId] = this.quickselect

                localStorage.setItem('basket_quickselect', JSON.stringify(quickselectStorage))

                if (this.isSet) {
                    const setComponents = []
                    this.$store.state.items.setComponentIds.forEach((itemId) => {
                        const setComponent = this.$store.getters[`${itemId}/currentItemVariation`]
                        const variationId = setComponent && setComponent.variation.id
                        // Extract order properties and total surcharge for set components
                        const setComponentOrderParamsAndSurcharge = extractPropertiesAndSurcharge(
                            setComponent.properties.filter((prop) => prop.property.isOderProperty),
                        )
                        setComponents.push({
                            variationId: variationId,
                            quantity: this.$store.state.items[itemId].variationOrderQuantity,
                            basketItemOrderParams: setComponentOrderParamsAndSurcharge.orderParams,
                            totalOrderParamsMarkup: setComponentOrderParamsAndSurcharge.totalSurcharge,
                        })
                    })
                    basketObject.setComponents = setComponents
                }

                this.$store.dispatch('addBasketItem', basketObject).then(
                    (response) => {
                        document.dispatchEvent(
                            new CustomEvent('afterBasketItemAdded', {
                                detail: basketObject,
                            }),
                        )
                        this.$store.commit('setIsAddToBasketLoading', 0)
                    },
                    (error) => {
                        this.$store.commit('setIsAddToBasketLoading', 0)
                        if (error.data) {
                            window.CeresNotificationService.error(
                                this.$translate('Ceres::Template.' + ExceptionMap.get(error.data.exceptionCode.toString()), error.data.placeholder),
                            ).closeAfter(5000)
                        }
                    },
                )

                if (this.quickselectIds) {
                    this.quickselectIds.forEach((id) => {
                        let quickselectBasketObject = {
                            variationId: id,
                            quantity: 1,
                            basketItemOrderParams: orderParamsAndSurcharge.orderParams,
                            totalOrderParamsMarkup: orderParamsAndSurcharge.totalSurcharge,
                        }

                        this.$store.commit('setIsAddToBasketLoading', id)
                        this.$store.dispatch('addBasketItem', quickselectBasketObject).then(
                            (response) => {
                                document.dispatchEvent(
                                    new CustomEvent('afterBasketItemAdded', {
                                        detail: quickselectBasketObject,
                                    }),
                                )
                                this.$store.commit('setIsAddToBasketLoading', 0)
                            },
                            (error) => {
                                this.$store.commit('setIsAddToBasketLoading', 0)
                                if (error.data) {
                                    window.CeresNotificationService.error(
                                        this.$translate(
                                            'Ceres::Template.' + ExceptionMap.get(error.data.exceptionCode.toString()),
                                            error.data.placeholder,
                                        ),
                                    ).closeAfter(5000)
                                }
                            },
                        )
                    })
                }
            }
        },

        showMissingPropertiesError() {
            this.$store.commit(`${this.itemId}/setVariationMarkInvalidProps`, true)
            const propertyNames = this.variationMissingProperties.map((property) => property.property.names.name)
            let errorMsgContent = ''
            for (const name of propertyNames) {
                errorMsgContent += name + '<br>'
            }
            window.CeresNotificationService.error(
                this.$translate('Ceres::Template.singleItemMissingOrderPropertiesError').replace('<properties>', errorMsgContent),
            )
        },

        directToItem() {
            navigateTo(this.itemUrl)
        },

        handleButtonState(value) {
            this.buttonLockState = value
        },

        /**
         * update the property quantity of the current instance
         * @param value
         */
        updateQuantity(value) {
            this.quantity = value
        },
    },

    watch: {
        quantity(value) {
            if (!isNullOrUndefined(this.itemId)) {
                this.$store.commit(`${this.itemId}/setVariationOrderQuantity`, value)
                this.$store.commit(`${this.itemId}/setVariationPropertySurcharges`, this.$store.getters[`${this.itemId}/variationBasePrice`])
            }
        },
        variationOrderQuantity(value) {
            if (this.quantity !== value) {
                this.quantity = value
            }
        },
        propQuantity(value) {
            if (!isNaN(value)) {
                this.quantity = value
            }
        },
    },
});

function extractPropertiesAndSurcharge(orderProperties) {
    let totalSurcharge = 0
    const orderParams = []
    orderProperties.forEach((orderProperty) => {
        if (!isNullOrUndefined(orderProperty.property.value)) {
            const property = orderProperty.property
            if (property.valueType === 'float' && !isNullOrUndefined(property.value) && property.value.slice(-1) === App.decimalSeparator) {
                property.value = property.value.substr(0, property.value.length - 1)
            }
            totalSurcharge += (orderProperty.surcharge || 0) + (property.surcharge || 0)
            orderParams.push({
                propertyId: property.id,
                type: property.valueType,
                name: property.names.name,
                value: property.value,
            })
        }
    })
    return {
        orderParams: orderParams,
        totalSurcharge: totalSurcharge,
    }
}


Vue.component("av-delivery-timeline", {

    template: '#av-delivery-timeline',

    data() {
        return {
            orderDate: new Date(),
            shippingStart: null,
            shippingEnd: null,
            deliveryDate: null,
            deliveryDateEnd: null,
        };
    },

    created() {
        this.calculateDates();
    },

    methods: {
        calculateDates() {
            let now = new Date();
            this.orderDate = now;

            // Basislieferzeit: 3 Werktage
            let daysToAdd = now.getHours() < 12 ? 2 : 3;

            this.deliveryDate = this.addBusinessDays(now, daysToAdd);

            this.deliveryDateEnd = this.addBusinessDays(now, daysToAdd + 2);

            // Versandfenster: zwischen Bestellung +1 und Lieferung -1
            this.shippingStart = this.addBusinessDays(now, 1);
            this.shippingEnd = this.addBusinessDays(now, daysToAdd - 1);
        },

        addBusinessDays(date, days) {
            let result = new Date(date);

            while (days > 0) {
                result.setDate(result.getDate() + 1);

                const isWeekend = result.getDay() === 0 || result.getDay() === 6;
                const isBlocked = this.isBlockedDate(result);

                if (!isWeekend && !isBlocked) {
                    days--;
                }
            }

            return result;
        },

        formatDate(date) {
            return date.toLocaleDateString("de-DE", {
                day: "2-digit",
                month: "short"
            });
        },

        isBlockedDate(date) {
            const day = date.getDate();
            const month = date.getMonth() + 1; // Januar = 1

            // 24.–26. Dezember
            if (month === 12 && day >= 24 && day <= 26) return true;

            // 01. Januar
            if (month === 1 && day === 1) return true;

            return false;
        }
    }
});

Vue.component("kuipers-single-item", {

    name: "kuipers-single-item",

    props: {
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false
        },
        showNetPrices: {
            type: Boolean,
            default: false
        },
        isWishListEnabled: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
            required: true
        },
        quickselect: Array,
        afterKey: Object
    },

    jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
    ],

    data() {
        return {
            quickselectIds: [],
        }
    },

    provide() {
        return {
            itemId: this.$props.itemId
        }
    },
    computed:
        {
            isMobile() {
                return window.innerWidth < 900;
            },
            itemConfig() {
                return App.config.item.itemData;
            },
            isDescriptionTabActive() {
                return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all"))
                    && !!this.currentVariation.texts.description.length;
            },
            isRecommendedPriceActive() {
                return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
            },
            isShortDescriptionActive() {
                return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
            },
            hasShippingCostsCategoryId() {
                return App.config.global.shippingCostsCategoryId > 0;
            },
            isTechnicalDataTabActive() {
                return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all"))
                    && !!this.currentVariation.texts.technicalData.length;
            },
            variationGroupedProperties() {
                return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
            },
            variationMissingProperties() {
                return this.$store.getters[`${this.itemId}/variationMissingProperties`];
            },
            currentVariation() {
                return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
            },
            isVariationSelected() {
                return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
            },
            attributes() {
                return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
            },
            units() {
                return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
            },
            isItemSet() {
                return this.$store.state.items.isItemSet;
            }
        },
    created() {
        this.$store.dispatch("initVariation", this.itemData);
        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
    },
    mounted() {
        this.$nextTick(() => {
            this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                itemId: this.itemId,
                attributes: this.attributesData,
                variations: this.variations,
                initialVariationId: this.currentVariation.variation.id,
                isPleaseSelectOption: this.initPleaseSelectOption,
                afterKey: this.afterKey
            });
            if (this.isItemSet) {
                this.$store.dispatch("initSetComponents", this.itemData);
            }

            setTimeout(() => {
                var productFacts = document.querySelector('.product-facts');
                var link = document.querySelector('.eg-tech-link');

                if (link) {
                    link.addEventListener('click', function () {
                        var offset = 30;
                        var elementPosition = (productFacts ? productFacts.getBoundingClientRect().top : 0) + window.pageYOffset;
                        var offsetPosition = elementPosition - offset;

                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });
                    });
                }


                var reviewObserver;

                function updateReviewHeader() {
                    var target = document.querySelector(".rating-placeholder");
                    var container = document.querySelector(".feedback-container");

                    if (!target || !container) {
                        return;
                    }

                    var overlayEl = container.querySelector(".feedback-stars-average > .feedback-stars-overlay-wrap");
                    var reviewCountEl = container.querySelector(".feedback-average-count");
                    var starsEl = container.querySelector(".feedback-stars-average");

                    if (!overlayEl || !reviewCountEl || !starsEl) {
                        return;
                    }

                    var widthStr = overlayEl.style.width;

                    if (!widthStr) {
                        return;
                    }

                    var widthNum = parseFloat(widthStr);

                    if (!widthNum || widthNum <= 0) {
                        return;
                    }

                    var rating = Math.round((widthNum / 100) * 5 * 10) / 10;
                    var existingWrap = document.querySelector(".eg-review-header");

                    if (!existingWrap) {
                        var clonedStars = starsEl.cloneNode(true);
                        var reviewWrap = document.createElement("div");
                        reviewWrap.className = "eg-review-header";

                        var text = document.createElement("a");
                        text.className = "eg-review-text";
                        text.href = "javascript:void(0)";

                        reviewWrap.appendChild(clonedStars);
                        reviewWrap.appendChild(text);

                        target.appendChild(reviewWrap);
                        existingWrap = reviewWrap;
                    }

                    var textEl = existingWrap.querySelector(".eg-review-text");

                    var newText =
                        rating +
                        " (" +
                        reviewCountEl.textContent.trim().replace(/[()]/g, "") +
                        " Bewertungen)";

                    if (textEl.textContent !== newText) {
                        textEl.textContent = newText;
                    }

                    var clonedOverlay = existingWrap.querySelector(
                        ".feedback-stars-average > .feedback-stars-overlay-wrap"
                    );

                    if (clonedOverlay) {
                        clonedOverlay.style.width = widthStr;
                    }
                }

                var container = document.querySelector(".feedback-container");

                if (!container) {
                    return;
                }

                reviewObserver = new MutationObserver(function () {
                    updateReviewHeader();
                });

                reviewObserver.observe(container, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ["style"]
                });

                updateReviewHeader();
            }, 2000)
        })
        // listen for variation change to hydrate all children lazy-hydrate components
        document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
    },
    methods:
        {
            isActive(itemId) {
                return this.quickselectIds.indexOf(itemId) !== -1
            },

            toggleQuickselectIds(itemId) {
                if (this.quickselectIds.indexOf(itemId) !== -1) {
                    let data = this.quickselectIds.find((e) => e != itemId)
                    this.quickselectIds = data ? (data.isArray ? data : [data]) : []
                } else {
                    this.quickselectIds.push(itemId)
                }
            },

            getDataField(field) {
                return get(this.currentVariation, field);
            },
            getFilteredDataField(field, filter) {
                if (!isNullOrUndefined(this.$options.filters[filter])) {
                    return this.$options.filters[filter](this.getDataField(field));
                }
                return this.getDataField(field);
            },
            // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
            hydrateChildren(nodes) {
                nodes.forEach(component => {
                    if (component.$options.name === "lazy-hydrate") {
                        component.hydrate();
                    } else if (component.$children.length) {
                        this.hydrateChildren(component.$children);
                    }
                })
            }
        }
});

Vue.component("item-availability", {
    name: "item-availability",

    template: "#item-availability",

    props: {
        paddingClasses: String,
        paddingStyles: String,
        attributeValueId: Number,
        attributeId: Number,
        selectedAttributes: Object,
    },

    inject: {
        itemId: {
            default: null
        }
    },

    data() {
        return {
            loading: false,
            customAvailability: null,
        }
    },

    computed:
        {
            availability() {
                const currentVariation = this.$store.getters[`${this.itemId}/currentItemVariation`];

                if (this.customAvailability) {
                    return this.customAvailability;
                }

                return currentVariation && currentVariation.variation && currentVariation.variation.availability;
            },

            classes() {
                return [
                    "availability",
                    "badge",
                    (this.loading || !this.availability ? 'availability-9' : "availability-" + this.availability.id),
                    this.paddingClasses
                ];
            },

            name() {
                if (this.loading) {
                    return 'Verfügbarkeit wird geprüft...';
                }

                if (this.customAvailability && this.customAvailability.names && this.customAvailability.names.name) {
                    return this.customAvailability.names.name;
                }

                return this.availability && this.availability.names && this.availability.names.name;
            },

            currentVariationSelect() {
                return this.$store.state.items[this.itemId] && this.$store.state.items[this.itemId].variationSelect;
            },

            variations() {
                return this.currentVariationSelect && this.currentVariationSelect.variations;
            }
        },

        created() {
            let variationId = this.getVariationIdByAttributeId();
            if (variationId) {
                this.loading = true;

                ApiService
                    .get("/rest/io/variations/" + variationId)
                    .done(response =>
                    {
                        if (response.documents && response.documents[0]) {
                            this.customAvailability =  response.documents[0].data.variation.availability;
                        }
                        this.loading = false;
                    });
            }

        },

        methods: {
            /**
             * returns true, if the selection with a new unitId would be valid
             */
            getVariationIdByAttributeId() {

                let variationId = null;

                if (!this.selectedAttributes) {
                    return variationId;
                }



                let found = null;
                this.variations.forEach((variation) => {
                    found = null;
                    if (variation.attributes) {
                        variation.attributes.forEach((attribute) => {
                            if (found === null && attribute.attributeId === this.attributeId && attribute.attributeValueId === this.attributeValueId) {
                                found = true;
                            } else if (!this.selectedAttributes[attribute.attributeId] || this.selectedAttributes[attribute.attributeId] !== attribute.attributeValueId) {
                                found = false
                            }
                        })
                    }

                    if (found) {
                        variationId = variation.variationId;
                    }
                })

                return variationId;
            },
        }
});